export default "__VITE_ASSET__91a1ffc5__"